export const packs = [
  {
    nombre: "Initial",
    id: 1,
    monedas: ["VIPHUESO"],
    inventario: [{ Water: 10, "Wheat seed": 10, Energy: 2, Wood: 2 }],
    tierras: [{ id: 3, nombre: "Wheat land" }],
    precio: 10,
  },
  {
    nombre: "General",
    id: 2,
    monedas: ["VIPHUESO"],
    inventario: [
      { 
        Water: 40, 
        "Corn seed": 20, 
        Energy: 8, 
        Wood: 8,
      },
    ],
    tierras: [{ id: 1, nombre: "Land of Corn" }],
    precio: 20,
  },
  {
    nombre: "Special",
    id: 3,
    monedas: ["VIPHUESO"],
    inventario: [{ Water: 60, 
      "Wheat seed": 50, 
      "Corn seed": 50, 
      Energy: 30, 
      Carbon: 30, 
      Wood: 30,
    }],
    tierras: [
      { id: 2, nombre: "Land of Corn" },
      { id: 4, nombre: "Wheat land" },
      { id: 5, nombre: "Land of Trees" },
      { id: 10, nombre: "Chicken coop" },
    ],
    precio: 30,
  },
  {
    nombre: "Energy pack",
    id: 4,
    monedas: ["VIPHUESO"],
    inventario: [
      { 
        Water: 40, 
        "Wheat seed": 20, 
        "Corn seed": 20, 
        Energy: 20, 
        Carbon: 10, 
        Wood: 10 
      }
    ],
    tierras: [{ id: 7, nombre: "Land of Trees" }, { id: 9, nombre: "Power plant" }],
    precio: 40,
  },
  {
    nombre: "Water production pack",
    id: 7,
    monedas: ["VIPHUESO"],
    inventario: [
      { 
      Water: 30, 
      "Wheat seed": 20, 
      "Corn seed": 20, 
      Energy: 20, 
      Carbon: 10, 
      Wood: 10, 
    },
  ],
    tierras: [{ id: 6, nombre: "Land of Trees" }, { id: 8, nombre: "Water well" }, { id: 11, nombre: "Cow farm" }],
    precio: 50,
  },
  {
    nombre: "Corn seed",
    id: 5,
    monedas: ["HUESO"],
    inventario: [{ "Corn seed": 20 }],
    tierras: [],
    precio: 0.2,
  },
  {
    nombre: "Wheat seed",
    id: 6,
    monedas: ["HUESO"],
    inventario: [{ "Wheat seed": 20 }],
    tierras: [],
    precio: 0.2,
  },
];
